export default {
      id: "header_accessi-usage",
      viewBox: "0 0 21.66 18.5",
      url: "../dist/images/" + "sprite.svg#header_accessi-usage",
      toString: function () {
        return this.url;
      }
    }